import React, { useState } from 'react';
import { ButtonFieldIcon, ButtonField, Iconsvg, SrOnly, Tooltip, TooltipBody } from '@wk/components-react16';
import AddPrivilege from './modal/AddPrivilege';
import AddRole from './modal/AddRole';
import PrivilegesDetails from './modal/PrivilegesDetails';
import { API_USER } from '../../core/constants';
import Api from '../../core/api';
import { logUserActivity, Toast, UserActivity } from '../../services';

const RoleManagement = ({ roleList, setIsLoad }: any) => {
    const [isPrivilegesOpen, setIsPrivilegesOpen] = useState(false)
    const [isAddPrivilegeOpen, setIsAddPrivilegeOpen] = useState(false)
    const [isAddRoleOpen, setIsAddRoleOpen] = useState(false)
    const [role, setRole] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const addEditRole = (role: any, type: boolean) => {
        setRole(role)
        setIsEdit(type)
        setIsAddRoleOpen(true);
        let userActivity: UserActivity = {
            action: type ? 'Edit Icon Click' : 'Add New Role' ,
            page: 'Role Management',
            viewName: type ? 'Edit Role Modal' : 'Add New Role Modal',
            entityName: type ? role.name : ''
        }
        logUserActivity(userActivity);
    }

    const deleteRole = (role: any) => {
        Api.deleteRequest(`${API_USER.DELETE_ROLE}/${role.id}`).then(
            (res: any) => {
                Toast("Role deleted successfully.", "sucsess");
                setIsLoad(true);
                let userActivity: UserActivity = {
                    action: 'Delete Icon Click',
                    page: 'Role Management',
                    viewName: 'Delete Role',
                    entityName: role.name
                }
                logUserActivity(userActivity);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <>
            <div className="wk-row">
                <div className="wk-col-12 text-right">
                    <ButtonFieldIcon size={'small16px'}>
                        <button
                            type="button"
                            id="showPrevileges"
                            title="Privileges Details"
                            className="mr-5" onClick={() => setIsPrivilegesOpen(true)}>
                            <Iconsvg name="info" color="#005b92"></Iconsvg>
                            <Iconsvg name="info" isFill color="#005b92"></Iconsvg>
                            <SrOnly>Info</SrOnly>
                        </button>
                    </ButtonFieldIcon>
                    <Tooltip identifier="tooltip-top"
                        position="top"
                        targetSelector="#showPrevileges">
                        <TooltipBody slot="tooltipBody">Privileges Details</TooltipBody>
                    </Tooltip>
                    <ButtonField size={'small'}>
                        <button type="button" className="mr-5" onClick={() => setIsAddPrivilegeOpen(true)}>
                            Add Privileges
                        </button>
                    </ButtonField>
                    <ButtonField size={'small'}>
                        <button type="button" className="mr-5" onClick={() => addEditRole({}, false)}>
                            Add Role
                        </button>
                    </ButtonField>
                </div>
            </div>
            <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th style={{ width: '250px' }}>Role</th>
                                <th>Privileges</th>
                                <th style={{ width: '80px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {roleList && roleList.map((item: any) => (
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <td><span>{item.privilegeString}</span></td>
                                    <td>
                                        <span className="wk-icon-pencil mr-10 cursor" title="Edit role"
                                            onClick={() => addEditRole(item, true)}></span>
                                        <span className="wk-icon-trash cursor" title="Delete role" onClick={() => deleteRole(item)}></span>
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <AddPrivilege isAddPrivilege={isAddPrivilegeOpen} setIsAddPrivilegeOpen={setIsAddPrivilegeOpen} />
            <PrivilegesDetails isPrivilegesOpen={isPrivilegesOpen} setIsPrivilegesOpen={setIsPrivilegesOpen} />
            {isAddRoleOpen && <AddRole isAddRoleOpen={isAddRoleOpen} setIsAddRoleOpen={setIsAddRoleOpen} role={role} isEdit={isEdit} setIsLoad={setIsLoad} />}
        </>
    );
};

export default RoleManagement;
